//region block: pre-declaration
//endregion
function systemProp(propertyName) {
  return null;
}
//region block: exports
export {
  systemProp as systemProp1h8dzpvpx9055,
};
//endregion

//# sourceMappingURL=SystemProps.mjs.map
